export const DEFAULT_DATATABLE_CONFIG = {
    rowButtons: [
        {
            template: '<span class="datatable-dropdown-wrapper pull-right"><button class="btn btn-md add-comment-btn" ><span class="caret"></span></button></span>',

        }
    ],
    dom: 'tS',
    responsive: true,
    paging: false,
    bFilter: true,
    deferRender: false,
    fixedHeader: true,
    scrollY: 380,
    scrollCollapse: true,
    scrollResize: true,
}
